<template>
	<div class='category'>
  	<div class="clearfix">
      <router-link :to="{name: 'categoryEdit'}" class="button is-info" >添加一级类目</router-link>
    </div>
    <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th v-for='item in list'>
              <div>{{item.definedCategoryInfo}}</div>
              <div><router-link :to="{name: 'categoryEdit', query: {categoryId: item.categoryId}}" class="button is-info" >编辑</router-link></div>
            	</th>
            </tr>
            </thead>
            <tbody>
            	<tr v-for='item in formatList'>
            		<td v-for='value in item'>{{value ? value.name : ''}}</td>
            	</tr>
            </tbody>
          </table>
        </article>
      </div>
	</div>
</template>

<script type="text/babel">
	export default {
		data() {
			return {
				list: [],
				formatList: []
			}
		},
		mounted() {
			this.getList()
			this.format()
		},
		methods: {
			getList() {
				HttpRequest.get('/admin.php?method=aicategoryinfo.getAiCategoryList').then(response => {
					this.list = response.data.list ? response.data.list: this.list
					this.format()
				})
			},
			format() {
				let maxLength = 0
				let listLength = this.list.length
				let temList = []
				this.list.forEach((item, index) => {
					if (maxLength < item.originNameList.length) {
						maxLength = item.originNameList.length
					}
				})
				let index = 0
				while(index < maxLength) {
					temList[index] = []
					this.list.forEach((value, key) => {
						temList[index].push(value.originNameList[index])
					})
					++index	
				}
				this.formatList = temList	
			}
				
		}
	}
</script>